import React, { useEffect } from 'react'

import { Container } from './styles'
import { twMerge } from 'tailwind-merge'

export default function ({ frente, costa }) {
	useEffect(() => {
		function handleFlipCard() {
			const card = document.querySelector('.card')

			if(card) {
				card.classList.toggle('flipped')
			}
		}

		const interval = setInterval(handleFlipCard, 4000)

		return () => {
			clearInterval(interval)
		}
	}, [])

	return (
		<Container className="container" frontImage={frente} backImage={costa}>
			<div className="card -mt-16 md:-mt-16 lg:-mt-28 w-[150px] h-[96px] lg:w-full lg:h-full">
				<div className="front"></div>

				<div className="back"></div>
			</div>
		</Container>
	)
}
